import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../../../navigators/NavigationProp';

import Index, {
  DispatchProps,
  StateProps,
} from '../../../../../components/scene_form/background_music_show_scene_command/edit/sound_usage_histories/Index';

import AppState from '../../../../../reducers/AppState';

import getSceneCommandForm from '../../../../../helpers/getSceneCommandForm';

import indexSoundUsageHistories, {
  Params as SoundUsageHistoryIndexParams,
} from '../../../../../actions/sound_usage_histories/index';
import updateSoundUsageHistory, {
  Params as SoundUsageHistoryUpdateParams,
} from '../../../../../actions/sound_usage_histories/update';
import createSceneCommandForm, {
  Params as SceneCommandFormCreateParams,
} from '../../../../../actions/scene_command_forms/create';
import updateSceneCommandForm, {
  Params as SceneCommandFormUpdateParams,
} from '../../../../../actions/scene_command_forms/update';

import selectEntities from '../../../../../helpers/selectEntities';
import selectEntity from '../../../../../helpers/selectEntity';
import {enabledResourceFavorite} from '../../../../../helpers/ResourceAuthorizattion';

import {SceneFormBackgroundMusicShowSceneCommandEditSoundUsageHistoriesRouteProp} from '../../../../../navigators/RouteProps';

interface Props {
  navigation: NavigationProp;
  route: SceneFormBackgroundMusicShowSceneCommandEditSoundUsageHistoriesRouteProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation, route} = props;
  const {entities, queries, forms, writerCurrentUserId} = state;
  const {storyId, sceneCommandId, parentSceneCommandId} = route.params;
  const currentUser = writerCurrentUserId
    ? selectEntity(entities.writer.currentUsers, writerCurrentUserId)
    : null;
  const sceneForm = forms.sceneForm;
  const soundUsageHistoriesParams: SoundUsageHistoryIndexParams = {
    storyId,
    soundType: 'background_music',
  };
  const sceneCommandForm = getSceneCommandForm(
    state.forms.sceneCommandForms,
    sceneCommandId,
  );
  const parentSceneCommandForm = getSceneCommandForm(
    state.forms.sceneCommandForms,
    parentSceneCommandId,
  );
  const soundUsageHistories = selectEntities(
    entities.soundUsageHistories,
    queries.soundUsageHistories,
    soundUsageHistoriesParams,
  );
  return {
    sceneForm,
    soundUsageHistories,
    soundUsageHistoriesParams,
    navigation,
    sceneCommandForm,
    parentSceneCommandForm,
    currentUser,
    enabledFavorite: enabledResourceFavorite(state),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    createSceneCommandForm: (params: SceneCommandFormCreateParams) =>
      dispatch(createSceneCommandForm(params)),
    updateSceneCommandForm: (params: SceneCommandFormUpdateParams) =>
      dispatch(updateSceneCommandForm(params)),
    indexSoundUsageHistories: (params: SoundUsageHistoryIndexParams) =>
      dispatch(indexSoundUsageHistories(params)),
    updateSoundUsageHistory: (
      id: number,
      params: SoundUsageHistoryUpdateParams,
    ) => dispatch(updateSoundUsageHistory(id, params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(Index);
